import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../API/api';
import dayjs from 'dayjs';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    token: null,
    user: null,
    role: null,
    expiresAt: null,
    roles: [],
    permissions: [],
  });

  const navigate = useNavigate();
  const [TokenExp, setTokenExp] = useState(null);

  // Check on mount if session is still valid
  useEffect(() => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    if (storedAuthState) {
      try {
        const parsed = JSON.parse(storedAuthState);
        const expiresAt = dayjs(parsed.expiresAt).format('YYYY-MM-DD HH:mm:ss');
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss');

        if (expiresAt <= now) {
          console.log('🔐 Token expired on load');
          handleTokenExpired();
        } else {
          setAuthState(parsed);
          setTokenExp(true);
         
        }
      } catch (error) {
        console.error('❌ Failed to parse auth state from sessionStorage', error);
        handleTokenExpired();
      }
    }
  }, []);

  //Auto-check for expiration every 1 minute
  useEffect(() => {
    const interval = setInterval(() => {
      if (authState.expiresAt) {
        const expiresAt =dayjs(authState.expiresAt).format('YYYY-MM-DD HH:mm:ss');
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
        
        if (expiresAt <= now) {
          console.log('⏰ Token expired during session');
          handleTokenExpired();
        }
      }
    }, 6000);

    return () => clearInterval(interval);
  }, [authState.expiresAt]);

  // 🔐 Token expired handler
  const handleTokenExpired = () => {
   // alert('⏰ Votre session a expiré. Veuillez vous reconnecter.');
    logout();
  };

  // Login method
  const login = (userData, token, expiresAt, role) => {
    const newAuthState = {
      isAuthenticated: true,
      user: userData,
      token: token,
      role: role,
      expiresAt: expiresAt,
      roles: [],
      permissions: [],
    };

    axios.get(`${API}/permissions/${userData.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
    newAuthState.permissions = res.data.permissions;

    if (role === 1) newAuthState.roles = ['admin', 'user'];
    else if (role === 2) newAuthState.roles = ['user'];
    else if (role === 3) newAuthState.roles = ['admin', 'user', 'super_admin'];
    else if (role === 4) newAuthState.roles = ['user-facture']; // Added user-facture

    setAuthState(newAuthState);
    sessionStorage.setItem('authLocalstorage', JSON.stringify(newAuthState));
    navigate('/Dashboard');
})
      .catch(err => {
        console.error('Error fetching permissions:', err);
      });
  };

  // Logout method
  const logout = () => {
    console.log('🔓 Logging out');
    setAuthState({
      isAuthenticated: false,
      token: null,
      user: null,
      role: null,
      expiresAt: null,
      roles: [],
      permissions: [],
    });
    sessionStorage.removeItem('authLocalstorage');
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ authState, login, logout, setAuthState, TokenExp }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
